<template>
  <qd-collapse
    class="card"
    animation="slide"
    :aria-id="`contentId${ligne.id}`">
    <template #trigger="props">
      <div
        :aria-expanded="props.open"
        class="card-header"
        role="button"
        :aria-controls="`contentId${ligne.id}`">
        <a class="card-header-icon">
          <b-icon :icon="getIcon().icon" :type="getIcon().type"></b-icon>
        </a>
        <p class="card-header-title">
          {{ getRouteDevisCommande().title }}
          <router-link-blank
            v-bind="getRouteDevisCommande(props.row)"
            class="lien mgr-5px">
          </router-link-blank>
          - {{ ligne.annonceur }}
        </p>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
        </a>
      </div>
    </template>

    <div class="card-content">
      <div class="content">
        <div class="columns is-vcentered">
          <div class="column is-8">
            <p>
              {{ $t('editCheminFer.libelleProduit') }}
              {{ ligne.lignePresse.libelle }}
            </p>
            <p>
              {{ $t('editCheminFer.libelleEncart') }}
              {{ ligne.ligneEncart.libelle }}
            </p>
            <p>
              {{ $t('editCheminFer.dateParution') }}
              {{ formatDate(ligne.lignePresse.dateDebut) }}
            </p>
          </div>
          <div class="column is-4 has-text-centered">
            <img v-if="url" :src="url" style="height: 200px"/>
            <div v-else class="has-text-danger has-text-weight-bold">
              {{ $t('editCheminFer.pasDeVisuel') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="card-footer">
      <a
        @click="$emit('addEncart')"
        :class="{ 'disabled': hasEncartPlace }"
        class="card-footer-item">
        {{ $t('editCheminFer.actions.placer') }}
      </a>
      <a
        @click="$emit('deleteEncart')"
        :class="{ 'disabled': !hasEncartPlace }"
        class="card-footer-item">
        {{ $t('editCheminFer.actions.supprimerPlacement') }}
      </a>
      <a
        @click="$emit('voirPage')"
        :class="{ 'disabled': !hasEncartPlace }"
        class="card-footer-item">
        {{ $t('editCheminFer.actions.voirPage') }}
      </a>
    </footer>
  </qd-collapse>
</template>

<script>
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'InfosEncartLigneCommande',
  props: {
    ligne: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: false,
    },
    hasEncartPlace: {
      type: Boolean,
    },
  },
  components: {
    RouterLinkBlank,
  },
  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    getIcon() {
      if (this.hasEncartPlace) return { icon: 'check-circle', type: 'is-success' };
      return { icon: 'timer-sand', type: 'is-warning' };
    },
    getRouteDevisCommande() {
      return {
        title: this.$t('editCheminFer.titleCommande'),
        message: this.ligne.codeDevisCommande,
        to: { name: 'c.bodac.commandes', params: { id: this.ligne.devisCommandeId } },
      };
    },
  },
};
</script>
